import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-11/12 flex flex-col justify-center items-center mx-auto" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_3 = { class: "flex items-center space-x-2 mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-full w-10 h-10 p-2 chip-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "mic")
], -1)
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "text-muted text-sm mt-8" }
const _hoisted_8 = {
  key: 0,
  class: "banner banner-light align-start mt-8"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined inline-icon text-muted opacity-70",
  style: {"font-size":"24px !important"}
}, " info ", -1)
const _hoisted_10 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_11 = { class: "font-semibold text-primary" }
const _hoisted_12 = {
  key: 1,
  class: "text-muted ml-0"
}
const _hoisted_13 = { class: "font-semibold text-primary" }
const _hoisted_14 = {
  key: 1,
  class: "w-11/12 flex flex-col justify-center items-center mx-auto"
}
const _hoisted_15 = { class: "flex flex-col items-center space-y-8" }
const _hoisted_16 = { class: "flex items-center w-full place-content-center space-x-20" }
const _hoisted_17 = { class: "flex items-center space-x-2" }
const _hoisted_18 = { class: "flex items-center space-x-2" }
const _hoisted_19 = {
  style: {"width":"2.4rem","height":"2.4rem"},
  class: "flex items-center rounded-full overflow-hidden p-2 bg-primary-light bg-opacity-20"
}
const _hoisted_20 = {
  style: {"stroke":"transparent","fill":"#6a16f0"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("title", null, "human-male-board", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("path", { d: "M20,17A2,2 0 0,0 22,15V4A2,2 0 0,0 20,2H9.46C9.81,2.61 10,3.3 10,4H20V15H11V17M15,7V9H9V22H7V16H5V22H3V14H1.5V9A2,2 0 0,1 3.5,7H15M8,4A2,2 0 0,1 6,6A2,2 0 0,1 4,4A2,2 0 0,1 6,2A2,2 0 0,1 8,4Z" }, null, -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "flex flex-col items-center space-y-2" }
const _hoisted_25 = { class: "transition-transform duration-200 ease-out transform material-icons-outlined" }
const _hoisted_26 = { class: "text-xs text-muted" }
const _hoisted_27 = {
  key: 0,
  class: "-mt-8"
}
const _hoisted_28 = {
  key: 0,
  class: "w-5/6 mt-8"
}
const _hoisted_29 = { class: "flex flex-wrap w-full pl-16 mt-12" }
const _hoisted_30 = { class: "text-lg font-semibold" }
const _hoisted_31 = { class: "flex flex-col h-full" }
const _hoisted_32 = { class: "flex items-center space-x-2" }
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = { class: "text-gray-500" }
const _hoisted_35 = { class: "text-xs text-gray-500 mt-1" }

import axios from "axios";
import { ref } from "vue";
import { onMounted, onBeforeUnmount } from "vue";
import { computed } from "vue";

import { useRoute, useRouter } from "vue-router";
import MicTalking from "../../components/shared/MicTalking.vue";
import Avatar from "../../components/ui/Avatar.vue";
import { useMetaStore } from "@/stores/metaStore";
import Card from "../../components/ui/Card.vue";
import Btn from "../../components/ui/Btn.vue";
import { watch } from "vue";
import ProcessedTextFragment from "../../components/ui/ProcessedTextFragment.vue";
import { setErrorNotification } from "../../utils";
import { getTranslatedString as _ } from "../../i18n";
import Countdown from "../../components/ui/Countdown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RealtimeSession',
  props: {},
  setup(__props) {

/* eslint-disable no-case-declarations */


const metaStore = useMetaStore();

const router = useRouter();

const openApiRealtimeBaseUrl = "https://api.openai.com/v1/realtime";

const runCountDown = ref(false);

const timeLimitSeconds = ref<number | null>(null);
const endTimestamp = computed(() => {
	if (!timeLimitSeconds.value) {
		return null;
	}
	const now = new Date();
	const endTime = new Date(now.getTime() + timeLimitSeconds.value * 1000);
	return endTime.getTime();
});
const rateLimit = ref<string | null>(null);
const rateLimitParsed = computed(() => {
	if (!rateLimit.value) {
		return null;
	}
	return rateLimit.value.split("/");
});

const route = useRoute();
const courseId = computed(() => route.params.courseId);

const isListening = ref(false);
const userTalking = ref(false);
const assistantTalking = ref(false);
const showStartInstructions = ref(false);
const hasFetchedFirstQuestion = ref(false);
const hasRequestedFirstQuestion = ref(false);

const pc = ref<RTCPeerConnection | null>(null);
const dataChannel = ref<RTCDataChannel | null>(null);
const audioStream = ref<MediaStream | null>(null);
const tracks = ref<RTCRtpSender[] | null>(null);

const eventId = ref<string | null>(null);
const participationId = ref<string | null>(null);

const sendClientEvent = (event: any) => {
	console.log("Sending event:", event);
	if (!dataChannel.value) {
		console.error("Data channel is not initialized");
		return;
	}
	dataChannel.value.send(JSON.stringify(event));
};

const beforeWindowUnload = (e: { preventDefault: () => void; returnValue: string }) => {
	if (
		(sessionState.value === "active" || sessionState.value === "starting") &&
		!window.confirm(_("misc.confirm_exiting_unsaved_changes"))
	) {
		// Cancel the event
		e.preventDefault();
		// Chrome requires returnValue to be set
		e.returnValue = "";
	}
};

const sessionLogs = ref([]);
watch(sessionLogs.value, () => {
	console.log(sessionLogs.value);
});

const sessionState = ref<"init" | "starting" | "active" | "ended">("init");

const hasMicPermission = ref(false);
const getMicPermission = async () => {
	try {
		const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
		stream.getTracks().forEach(track => track.stop());
		const granted = await navigator.permissions
			.query({ name: "microphone" })
			.then(({ state }) => state === "granted");
		hasMicPermission.value = granted;
	} catch (e) {
		console.error(e);
		hasMicPermission.value = false;
	}
};

const questions = ref<
	{
		id: string;
		text: string;
		solution: string;
	}[]
>([]);
const currentQuestion = computed(() =>
	questions.value.length > 0 ? questions.value[questions.value.length - 1] : null,
);
const showCurrentQuestion = ref(true);
watch(
	() => currentQuestion.value?.id,
	(newVal, oldVal) => {
		if (newVal !== oldVal) {
			showCurrentQuestion.value = false;
			setTimeout(() => {
				showCurrentQuestion.value = true;
			}, 1000);
		}
	},
);

const gradedQuestions = ref<
	{ score: number; summary: string; comment: string; expanded?: boolean }[]
>([
	// {
	// 	score: 0,
	// 	summary: "Great job!",
	// 	comment: "You did really well on this assignment.",
	// },
	// {
	// 	score: 0,
	// 	summary: "Great job!",
	// 	comment: "You did really well on this assignment.",
	// },
	// {
	// 	score: 0,
	// 	summary: "Great job!",
	// 	comment: "You did really well on this assignment.",
	// },
	// {
	// 	score: 0,
	// 	summary: "Great job!",
	// 	comment: "You did really well on this assignment.",
	// },
	// {
	// 	score: 0,
	// 	summary: "Great job!",
	// 	comment: "You did really well on this assignment.",
	// },
	// {
	// 	score: 0,
	// 	summary: "Great job!",
	// 	comment: "You did really well on this assignment.",
	// },
]);

const fns = {
	grade_answer_and_get_next_question: async ({
		score,
		summary,
		comment,
	}: {
		score: number;
		summary: string;
		comment: string;
	}) => {
		gradedQuestions.value.push({ score, summary, comment, expanded: false });
		await axios.post(`courses/${courseId.value}/realtime_session_grade_answer/`, {
			score,
			summary,
			comment,
		});
		try {
			const { data: nextQuestion } = await axios.post(
				`courses/${courseId.value}/realtime_session_get_question/?advance=true`,
			);
			questions.value.push(nextQuestion);
			return nextQuestion;
		} catch {
			return { text: null };
		}
	},
	get_first_question: async () => {
		const { data: firstQuestion } = await axios.post(
			`courses/${courseId.value}/realtime_session_get_question/?advance=false`,
		);
		questions.value.push(firstQuestion);
		if (!hasFetchedFirstQuestion.value) {
			// update the session to stop forcing tool call
			sendClientEvent({
				type: "session.update",
				session: {
					tool_choice: "auto",
				},
			});
			hasFetchedFirstQuestion.value = true;
		}
		return firstQuestion;
	},
	end_session: async () => {
		endSession();
	},
};

const onTranscriptDone = async (transcript: string, role: "user" | "assistant") => {
	await axios.post(`courses/${courseId.value}/realtime_session_append_answer/`, {
		role,
		text: transcript,
	});
};

const endSession = async () => {
	if (sessionState.value !== "active") {
		return;
	}

	// avoid closing the session while the assistant is still talking
	await new Promise(resolve => setTimeout(resolve, 1500));
	while (assistantTalking.value) {
		await new Promise(resolve => setTimeout(resolve, 100));
	}

	await axios.post(`courses/${courseId.value}/realtime_session_end/`);
	sessionState.value = "ended";

	pc.value?.close();
	pc.value = null;

	dataChannel.value?.close();
	dataChannel.value = null;

	if (audioStream.value) {
		audioStream.value.getTracks().forEach(track => track.stop());
	}
	audioStream.value = null;

	isListening.value = false;

	await router.push({
		name: "PracticeSummaryPage",
		params: {
			participationId: participationId.value,
			examId: eventId.value,
			showSubmissionConfirmationMessage: 1, // should be `true`, but TS complains about type
		},
	});
	metaStore.showSuccessFeedback();
};

onBeforeUnmount(() => {
	window.removeEventListener("beforeunload", beforeWindowUnload);
	endSession();
});

const handleFunctionCall = async ({ functionName, functionArgs, callId }) => {
	try {
		const response = (await fns[functionName](functionArgs)) ?? { status: "ok" };
		const event = {
			type: "conversation.item.create",
			item: {
				type: "function_call_output",
				call_id: callId,
				output: JSON.stringify(response),
			},
		};
		sendClientEvent(event);
		sendClientEvent({ type: "response.create" });
	} catch (error) {
		setErrorNotification(_("misc.error_occurred"), true);
		console.error("Error handling function call:", error);
	}
};

async function init() {
	await getMicPermission();

	sessionState.value = "starting";
	// Get an ephemeral key from your server - see server code below
	let tokenResponse = null;
	try {
		tokenResponse = await axios.post(`courses/${courseId.value}/realtime_session/`);
	} catch (error) {
		// check if rate limit is reached
		if (error.response.status === 429) {
			setErrorNotification(_("misc.rate_limit_usage_reached"), true);
			sessionState.value = "init";
			return;
		}
	}
	const data = tokenResponse.data;
	const EPHEMERAL_KEY = data.client_secret.value;

	eventId.value = data.event_id;
	participationId.value = data.participation_id;

	// Create a peer connection
	pc.value = new RTCPeerConnection();

	// Set up to play remote audio from the model
	const audioEl = document.createElement("audio");
	audioEl.autoplay = true;
	pc.value.ontrack = e => (audioEl.srcObject = e.streams[0]);

	await startRecording();

	// Set up data channel for sending and receiving events
	dataChannel.value = pc.value.createDataChannel("oai-events");
	dataChannel.value.addEventListener("message", (e: MessageEvent) => {
		// Realtime server events appear here!
		const data = JSON.parse(e.data);
		const type = data.type;

		// console.log("Received event:", type, data);

		switch (type) {
			case "response.done":
				sessionLogs.value.push(data);
				break;
			// function calls
			case "response.function_call_arguments.delta":
				break;
			case "response.function_call_arguments.done":
				console.log("Function call arguments:", data.arguments);
				const functionName = data.name;
				const callId = data.call_id;
				const functionArgs = JSON.parse(data.arguments);
				handleFunctionCall({ functionName, functionArgs, callId });
				break;
			// audio transcript
			case "response.audio_transcript.delta":
				break;
			case "response.audio_transcript.done":
				console.log("Assistant transcript:", data.transcript);
				onTranscriptDone(data.transcript, "assistant");
				break;
			case "conversation.item.input_audio_transcription.completed":
				console.log("User transcript:", data.transcript);
				onTranscriptDone(data.transcript, "user");
				break;
			// audio response
			case "response.audio.done":
				break;
			case "input_audio_buffer.speech_started":
				userTalking.value = true;
				assistantTalking.value = false;
				setTimeout(() => {
					if (showStartInstructions.value) {
						showStartInstructions.value = false;
						runCountDown.value = true;
					}
				}, 500);
				if (!hasRequestedFirstQuestion.value) {
					// temporarily update session to force tool call
					sendClientEvent({
						type: "session.update",
						session: {
							tool_choice: "required",
						},
					});
					hasRequestedFirstQuestion.value = true;
				}
				break;
			case "input_audio_buffer.speech_stopped":
				userTalking.value = false;
				break;
			case "output_audio_buffer.started":
				assistantTalking.value = true;
				break;
			case "output_audio_buffer.stopped":
				assistantTalking.value = false;
				break;
			// default:
			// console.log("Unknown event type", type, data);
		}
	});

	// Start the session using the Session Description Protocol (SDP)
	const offer = await pc.value.createOffer();
	await pc.value.setLocalDescription(offer);

	const model = "gpt-4o-realtime-preview-2024-12-17";
	const sdpResponse = await axios.post(
		`${openApiRealtimeBaseUrl}?model=${model}`,
		offer.sdp,
		{
			headers: {
				Authorization: `Bearer ${EPHEMERAL_KEY}`,
				"Content-Type": "application/sdp",
			},
		},
	);

	const answer = {
		type: "answer",
		sdp: sdpResponse.data,
	};

	await pc.value.setRemoteDescription(answer);

	sessionState.value = "active";

	setTimeout(() => {
		showStartInstructions.value = true;
	}, 500);
}

onMounted(async () => {
	window.addEventListener("beforeunload", beforeWindowUnload);
	const {
		data: { rate_limit, session_time_limit },
	} = await axios.get(`courses/${courseId.value}/realtime_session_info/`);
	rateLimit.value = rate_limit;
	timeLimitSeconds.value = session_time_limit ?? 5 * 60;
});

// Grabs a new mic track and replaces the placeholder track in the transceiver
const startRecording = async () => {
	try {
		const newStream = await navigator.mediaDevices.getUserMedia({
			audio: true,
		});
		audioStream.value = newStream;

		// If we already have an audioSender, just replace its track:
		if (tracks.value) {
			const micTrack = newStream.getAudioTracks()[0];
			tracks.value.forEach(sender => {
				sender.replaceTrack(micTrack);
			});
		} else if (pc.value) {
			// Fallback if audioSender somehow didn't get set
			newStream.getTracks().forEach(track => {
				const sender = pc.value?.addTrack(track, newStream);
				if (sender) {
					tracks.value = [...(tracks.value || []), sender];
				}
			});
		}

		isListening.value = true;
		console.log("Microphone started.");
	} catch (error) {
		console.error("Error accessing microphone:", error);
	}
};

// Replaces the mic track with a placeholder track
function stopRecording() {
	isListening.value = false;

	if (userTalking.value) {
		userTalking.value = false;
		sendClientEvent({ type: "input_audio_buffer.commit" });
		sendClientEvent({ type: "response.create" });
	}

	// Stop existing mic tracks so the user's mic is off
	if (audioStream.value) {
		audioStream.value.getTracks().forEach(track => track.stop());
	}
	audioStream.value = null;

	// Replace with a placeholder (silent) track
	if (tracks.value) {
		const placeholderTrack = createEmptyAudioTrack();
		tracks.value.forEach(sender => {
			sender.replaceTrack(placeholderTrack);
		});
	}
}

function createEmptyAudioTrack(): MediaStreamTrack {
	const audioContext = new AudioContext();
	const destination = audioContext.createMediaStreamDestination();
	return destination.stream.getAudioTracks()[0];
}

const onTimeUp = async () => {
	// don't interrupt the assistant if it's still talking
	while (assistantTalking.value) {
		await new Promise(resolve => setTimeout(resolve, 500));
	}
	// stop the user from talking
	await new Promise(resolve => setTimeout(resolve, 500));
	userTalking.value = false;
	stopRecording();

	sendClientEvent({
		type: "session.update",
		session: {
			tool_choice: "required",
		},
	});
	sendClientEvent({
		type: "response.create",
		response: {
			instructions:
				"Il tempo a disposizione per questa sessione è terminato. Informa lo studente che la sessione è terminata, poi chiama la funzione `end_session`.",
		},
	});
	sendClientEvent({ type: "response.create" });
};

// ! TODO TEST
// setTimeout(() => {
// 	sendClientEvent({
// 		type: "response.create",
// 		response: {
// 			instructions: `
//                 Ricorda allo studente che la sessione terminerà tra 5 minuti.
//               `,
// 		},
// 	});
// }, 35500);

// function sendTextMessage(message) {
// 	const event = {
// 		type: "conversation.item.create",
// 		item: {
// 			type: "message",
// 			role: "user",
// 			content: [
// 				{
// 					type: "input_text",
// 					text: message,
// 				},
// 			],
// 		},
// 	};
// 	sendClientEvent(event);
// 	sendClientEvent({ type: "response.create" });
// }

/**
 *






  ---- example for handling calls with additional instructions ---
  if (
          output.type === "function_call" &&
          output.name === "display_color_palette"
        ) {
          setFunctionCallOutput(output);
          setTimeout(() => {
            sendClientEvent({
              type: "response.create",
              response: {
                instructions: `
                ask for feedback about the color palette - don't repeat
                the colors, just ask if they like the colors.
              `,
              },
            });
          }, 500);

 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (sessionState.value === 'init' || sessionState.value === 'starting')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("realtime.title")), 1)
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("realtime.description")), 1),
          _createVNode(Btn, {
            class: "mt-6 mb-2 mx-auto",
            loading: sessionState.value === 'starting',
            onClick: init
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("realtime.start")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("realtime.disclaimer")), 1),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (rateLimit.value || timeLimitSeconds.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", null, [
                      (rateLimit.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                            _createTextVNode(_toDisplayString(_ctx.$t("misc.you_can_use_this_feature")) + " ", 1),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(rateLimitParsed)[0]) + " " + _toDisplayString(_ctx.$t("misc.times")), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`misc.per_${_unref(rateLimitParsed)[1]}`)) + ". ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (timeLimitSeconds.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                            _createTextVNode(_toDisplayString(_ctx.$t("realtime_sessions.time_limit_1")) + " ", 1),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(timeLimitSeconds.value / 60) + " " + _toDisplayString(_ctx.$t("misc.minutes")), 1),
                            _createTextVNode(". ")
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(Avatar, {
                  user: _unref(metaStore).user,
                  size: 'lg'
                }, null, 8, ["user"]),
                _createVNode(MicTalking, { talking: userTalking.value }, null, 8, ["talking"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(MicTalking, { talking: assistantTalking.value }, null, 8, ["talking"]),
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_23))
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-start space-x-8 my-4", [
						!showStartInstructions.value && (runCountDown.value || !_unref(endTimestamp))
							? 'opacity-100'
							: 'opacity-0',
						'transition-opacity duration-200 ease-in-out',
					]])
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(Btn, {
                  class: "bg-primary bg-opacity-20 text-primary rounded-full",
                  outline: true,
                  variant: 'transparent',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isListening.value ? stopRecording() : startRecording()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(isListening.value ? "mic" : "mic_off"), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", _hoisted_26, "Mic " + _toDisplayString(isListening.value ? "on" : "off"), 1)
              ]),
              (_unref(endTimestamp))
                ? (_openBlock(), _createBlock(Countdown, {
                    key: 0,
                    class: "mt-1",
                    onTimeUp: onTimeUp,
                    endTimestamp: _unref(endTimestamp),
                    isInitialized: runCountDown.value
                  }, null, 8, ["endTimestamp", "isInitialized"]))
                : _createCommentVNode("", true)
            ], 2),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (showStartInstructions.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("realtime.say_start")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (_unref(currentQuestion) && showCurrentQuestion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(ProcessedTextFragment, {
                      class: "user-content",
                      value: _unref(currentQuestion).text
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gradedQuestions.value, (question, index) => {
              return (_openBlock(), _createBlock(Card, {
                key: index,
                class: _normalizeClass(['w-1/3 mr-4 mb-4', index % 3 === 0 ? '-ml-16' : ''])
              }, {
                header: _withCtx(() => [
                  _createElementVNode("h1", _hoisted_30, _toDisplayString(_ctx.$t("misc.question")) + " " + _toDisplayString(index + 1), 1)
                ]),
                body: _withCtx(() => [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("misc.score")) + ":", 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["text-sm font-semibold text-primary", {
										'text-primary-light': question.score < 5,
										'text-primary': question.score >= 5,
									}])
                      }, _toDisplayString(question.score), 3)
                    ]),
                    _createElementVNode("p", _hoisted_34, _toDisplayString(question.comment), 1),
                    _createVNode(Btn, {
                      class: "ml-auto",
                      outline: true,
                      variant: 'icon',
                      onClick: ($event: any) => (question.expanded = !question.expanded)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["transition-transform duration-200 ease-out transform material-icons-outlined", { 'rotate-180': question.expanded }])
                        }, " expand_more ", 2)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["duration-200 ease-in-out transition-max-height", {
									'max-h-0 overflow-hidden': !question.expanded,
									'max-h-32 overflow-y-auto': question.expanded,
								}])
                    }, [
                      _createElementVNode("p", _hoisted_35, _toDisplayString(question.summary), 1)
                    ], 2)
                  ])
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128))
          ])
        ]))
  ]))
}
}

})